import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TextToSpeechService {

  private _isActive:boolean = false;
  private _isHiContrast: boolean = false;
  public isHighContrastSub = new BehaviorSubject<boolean>(this._isHiContrast);

  public get isActive() : boolean {
    return this._isActive;
  }
  
  public get isHiContrast() : boolean {
    return this._isHiContrast;
  }

  constructor() { }

  toggle(){
    this._isActive = !this._isActive;
  }

  hi_contrast_toggle(){
    this._isHiContrast = !this._isHiContrast
    this.isHighContrastSub.next(this._isHiContrast)
  }

  hi_contrast_off() {
    this._isHiContrast = false;
    this.isHighContrastSub.next(this._isHiContrast)
  }
}
